// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [];

module.exports = angular
  .module('bench.ui.setFocus', deps)

  .directive('blSetFocus', ($timeout, $parse) => ({
    restrict: 'A',
    scope: true,
    link(scope, element, attrs) {
      const model = $parse(attrs.blSetFocus);

      scope.$watch(model, value => {
        if (value) {
          return $timeout(() => element[0].focus());
        }
      });

      return element.bind('blur', () => scope.$apply(model.assign(scope, false)));
    },
  }));
